"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterOutRecommendedProducts = exports.getDetailTileArdadImages = exports.getArdadAssetFromVariant = exports.api = void 0;
const pattern_library_modules_selection_1 = require("@saatva-bits/pattern-library.modules.selection");
const SKIP_RECOSTRIP_FILTERING = [
    'pillows',
    'pads',
    'topper'
];
const api = async (uri, { query, variables, prismicRef }) => {
    try {
        const fetchOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // Compress the response, otherwise the query will take a long time.
                'Accept-Encoding': `gzip, deflate, br`
            },
            body: JSON.stringify({
                query,
                variables: variables || {}
            })
        };
        if (prismicRef) {
            fetchOptions.headers['prismic-ref'] = prismicRef;
        }
        const response = await fetch(uri, fetchOptions);
        const { data } = await response.json();
        return data;
    }
    catch (error) {
        throw new Error(error);
    }
};
exports.api = api;
const getArdadAssetFromVariant = (variant, descriptor, ratio) => {
    let asset = { folder: null, file: null, alt: null };
    try {
        asset = (0, pattern_library_modules_selection_1.getAssetForVariant)(variant, descriptor, ratio);
    }
    catch (error) {
        console.error({
            message: 'Cannot find ARDAD asset for variant',
            location: 'reco-strip/utils.js',
            error,
            details: {
                productCode: variant.productCode,
                sku: variant.sku,
                descriptor
            },
            enableClientAlerts: true,
        });
    }
    return asset;
};
exports.getArdadAssetFromVariant = getArdadAssetFromVariant;
/**
 * Get the ARDAD images for the product tiles
 *
 * @param {array} ardadDescriptors - ARDAD descriptors set in Prismic
 * @param {object} selectedVariant - The product variant where the assets are obtained
 * @param {string} ratio - Ratio for the image
 * @returns {{
*   defaultImage: { folder: string, name: string, alt: string },
* }}
*/
const getDetailTileArdadImages = (ardadDescriptors, selectedVariant, ratio = '4-3') => {
    const [ardadDefaultImage] = ['product-tile'].map(slot => {
        const descriptor = ardadDescriptors.find(descriptorDef => descriptorDef.slot == slot).descriptors;
        const { folder, file } = (0, exports.getArdadAssetFromVariant)(selectedVariant, descriptor[0], ratio);
        return {
            folder,
            name: file,
            alt: selectedVariant.genericName
        };
    });
    return {
        defaultImage: ardadDefaultImage
    };
};
exports.getDetailTileArdadImages = getDetailTileArdadImages;
/**
 * Filter out recommended products that are already in the cart
 * @param {array} allRecommendedProducts
 * @param {{items: array}} cart
 * @returns {array}
 */
const filterOutRecommendedProducts = (allRecommendedProducts = [], cart = { items: [] }) => {
    try {
        if (!cart || !allRecommendedProducts) {
            return [];
        }
        const items = cart.items || [];
        const { productCodes, productTypes } = items.reduce((acc, item) => {
            acc.productCodes.push(item.productCode);
            acc.productTypes.push(item.magentoProductType);
            return acc;
        }, {
            productCodes: [],
            productTypes: []
        });
        return (allRecommendedProducts
            .filter((product) => {
            const productType = product.magentoProductType;
            // Filter out products already in the cart
            const productNotInCart = productCodes.includes(product.productCode);
            // Filter out products of the same mangetoProductType
            const productTypeAlreadyInCart = !productTypes.includes(productType);
            // Some productTypes will be skipped from filtering
            const skipFiltering = SKIP_RECOSTRIP_FILTERING.includes(productType.toLowerCase());
            // Show product if filtering does not apply to it
            // but it is not already in the cart
            if (skipFiltering && !productNotInCart) {
                return true;
            }
            // Hide the product if there is already another product with the same productType
            return !productNotInCart && productTypeAlreadyInCart;
        })
            // Adjust the length of the list to 8 items for all devices
            .splice(0, 8));
    }
    catch (error) {
        console.error(error);
        return [];
    }
};
exports.filterOutRecommendedProducts = filterOutRecommendedProducts;
//# sourceMappingURL=utils.js.map